<template>
  <v-system-bar type="info" class="justify-center" app window v-if="alert">
    <div>
      <span class="pr-2">gg-bus.com 이 새롭게 개편되었습니다.</span>
      <a href="https://old.gg-bus.com/">이전 사이트로 접속하기</a>
    </div>
    <v-icon clickable class="core-systembar__close" @click="alert = false">mdi-close</v-icon>
  </v-system-bar>
</template>

<script>
export default {
  data () {
    return {
      alert: true
    }
  }
}
</script>

<style scoped>
  .core-systembar__close {
    position: absolute;
    right: 0;
  }
</style>
